import type { ReactNode } from 'react';

type FormFieldProps = {
  label: string;
  required?: boolean;
  children: ReactNode;
  hint?: string;
};

export function FormField({ label, required, children, hint }: FormFieldProps) {
  return (
    <div>
      <label className='mb-1 block text-sm font-semibold text-gray-900'>
        {label} {required && <span className='text-red-600'>*</span>}
      </label>
      {children}
      {hint ? <label className='mt-2 block text-xs text-gray-400'>{hint}</label> : null}
    </div>
  );
}
